export default __webpack_public_path__ + "static/media/file.7a81c496.svg";